import { Route } from "react-router-dom";
import RelatorioSOSComprasPrivatePage from "../../pages/private/reports/compras_sos";
import RelatoriosPagamentosPrivatePage from "../../pages/private/reports/financeiroPagamentos";
import RelatoriosMovimentacaoEmpresasPrivatePage from "../../pages/private/reports/movimentacao_empresas";
import RelatoriosUsuariosPrivatePage from "../../pages/private/reports/user";

const RoutesReports = () => {
  return (
    <Route path="/relatorios">
      <Route path="pagamentos" element={<RelatoriosPagamentosPrivatePage />} />
      <Route path="sos" element={<RelatorioSOSComprasPrivatePage />} />
      <Route path="usuario" element={<RelatoriosUsuariosPrivatePage />} />
      <Route
        path="movimentacao"
        element={<RelatoriosMovimentacaoEmpresasPrivatePage />}
      />
    </Route>
  );
};

export default RoutesReports;
